<template>
  <div class="checkout-builder-settings-menu">
    <div class="selected-tab">
      <snow-button
        v-if="activeScope.parent"
        size="sm"
        variant="outline"
        icon="ph ph-caret-left"
        @click="back"
      />
      <h5 class="text-dark-40">{{ activeScope.name }}</h5>
    </div>

    <div class="flex-fill overflow-y-scroll px-4">
      <template v-if="activeScope.options">
        <button
          v-for="option in activeScope.options"
          class="option-cell"
          :class="{ 'd-none d-lg-flex': option == 'elements' }"
          :key="option"
          @click="scope = option"
        >
          <bp-icon :size="20" :icon="scopes[option].icon" />
          <span class="fs-14">{{ scopes[option].name }}</span>
        </button>
      </template>

      <component
        v-else-if="activeScope.component"
        :is="activeScope.component"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BackgroundColor from "./background/BackgroundColor.vue";
import BackgroundImage from "./background/BackgroundImage.vue";

import DraggableElements from "./elements/DraggableElements.vue";

const scopes = {
  settings: {
    icon: "fa-regular fa-gear",
    name: "Configuração",
    options: [
      "background",
      "elements"
      // "popups",
      // "notifications"
    ]
  },

  background: {
    parent: "settings",
    icon: "ph ph-swatches",
    name: "Plano de fundo",
    options: ["background-color", "background-image"]
  },
  "background-color": {
    parent: "background",
    icon: "ph ph-palette",
    name: "Cor",
    component: BackgroundColor
  },
  "background-image": {
    parent: "background",
    icon: "ph ph-image",
    name: "Imagem",
    component: BackgroundImage
  },

  elements: {
    parent: "settings",
    icon: "ph ph-shapes",
    name: "Elementos",
    component: DraggableElements
  }
  // popups: {
  //   parent: "settings",
  //   icon: "fa fa-square-dashed-circle-plus",
  //   name: "Pop-ups"
  // },
  // notifications: {
  //   parent: "settings",
  //   icon: "fa fa-message-plus",
  //   name: "Notificações"
  // }
};
export default {
  data() {
    return {
      scopes,
      scope: "settings",
      previousScope: ""
    };
  },
  computed: {
    ...mapState("checkoutBuilder", ["snapshots", "components", "background"]),
    activeScope() {
      return scopes[this.scope];
    }
  },
  methods: {
    back() {
      this.scope = this.activeScope?.parent;
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-settings-menu {
  height: 100%;
  display: flex;
  flex-direction: column;

  .selected-tab {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
  }

  .option-cell {
    background-color: transparent;
    align-items: center;
    padding: 12px;
    border-radius: 12px;
    display: flex;
    border: none;
    width: 100%;
    gap: 12px;

    &:hover {
      background-color: rgba(25, 25, 34, 0.02);
    }
    &:active {
      background-color: rgba(25, 25, 34, 0.04);
      border-right: 2px solid var(--blue);
      span {
        color: var(--blue);
      }
    }
  }

  .reverse-button {
    padding: 16px;
    backdrop-filter: blur(20px);
    background: var(--Surface-Solid-28, #fff);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
  }
}
</style>
